<!-- =========================================================================================
    File Name: VxBreadcrumb.vue
    Description: Breadcrumb component
    Component Name: VxBreadcrumb
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <div class="vx-breadcrumb" :class="data.staticClass">
    <ul class="flex flex-wrap items-center">
      <li
        v-for="(link, index) in props.route.meta.breadcrumb.slice(0, -1)"
        :key="index"
        class="inline-flex items-center"
      >
        <router-link :to="link.url" v-if="link.url"
          ><span :style="$options.linkColor(link.color)">{{
            link.title
          }}</span></router-link
        >
        <span class="text-primary cursor-default" v-else
          ><span :style="$options.linkColor(link.color)">{{
            link.title
          }}</span></span
        >
        <span class="breadcrumb-separator mx-2 flex items-start"
          ><feather-icon
            :icon="props.isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
            svgClasses="w-4 h-4"
        /></span>
      </li>
      <li class="inline-flex">
        <span
          v-if="props.route.meta.breadcrumb.slice(-1)[0].active"
          class="cursor-default"
          >{{ props.route.meta.breadcrumb.slice(-1)[0].title }}</span
        >
      </li>
    </ul>
    <port-master-navigation
      v-if="props.route.meta.portMasterNavigation"
    ></port-master-navigation>
    <crew-setting-navigation
      v-if="props.route.meta.crewSettingNavigation"
    ></crew-setting-navigation>
    <crew-operator-navigation
      v-if="props.route.meta.crewOperatorNavigation"
    ></crew-operator-navigation>
  </div>
</template>

<script>
import Vue from "vue";
import PortMasterNavigation from "@/views/enterprise/addon/port-master/components/PortMasterNavigation.vue";
import CrewSettingNavigation from "@/views/enterprise/management/crews/page-layout-template/components/CrewSettingNavigation.vue";
import CrewOperatorNavigation from "@/views/enterprise/management/crew-operator/components/CrewOperatorNavigation.vue";

Vue.component("port-master-navigation", PortMasterNavigation);
Vue.component("crew-setting-navigation", CrewSettingNavigation);
Vue.component("crew-operator-navigation", CrewOperatorNavigation);

export default {
  name: "vx-breadcrumb",
  linkColor: function(color) {
    return color ? "color:" + color + ";" : null;
  },
};
</script>
<style lang="scss" scoped>
.vx-breadcrumb {
  display: flex;
  flex-grow: 1;
}
</style>
